import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { addFieldValue } from "../../redux/inspectionSlice";
import { surveySelector } from "../../redux/surveySlice";

const LabelRadio = ({ setUse, uses, fieldId, name }) => {
  const { currentUse } = useSelector(surveySelector);
  return (
    <>
      <input
        type="radio"
        onClick={() => setUse(uses)}
        onChange={() => console.log()}
        id={fieldId}
        name={name}
        className="radioText"
        checked={currentUse === uses}
      />
      <label htmlFor={fieldId}>{uses}</label>
    </>
  );
};

export default LabelRadio;
